import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Row } from 'reactstrap'
import { Table,Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const FinanceReportGeneration = ({dateData,dataForReport,reportType}) => {

  const today = new Date().toISOString().split('T')[0]; // "YYYY-MM-DD"

    // Style object for the sticky table headers
    const stickyHeaderStyle = {
    position: "sticky",
    top: 0,
    backgroundColor: "white",
    zIndex: 1, // Ensures header is above the scrolling content
    };

    // state for setting the report data
    const[report,setReport] = useState([]);
    console.log(report)
    // state for status count
    const[status,setStatus] = useState([]);
    console.log(status)
    useEffect(()=>{
      if(dataForReport){
        setReport(dataForReport.results)
        setStatus(dataForReport.status_count || [])
      }
    },[dataForReport])

    const reportColumns = {
      credit_report: [
          { header: "User", key: "user_name" },
          { header: "Order Number", key: "order" },
          { header: "Product Type", key: "product_type" },
          { header: "Credit Used", key: "credit_used" },
          { header: "Order Date", key: "created_date" },
          { header: "Status", key: "status" },
      ],

      payment_report: [
          { header: "User", key: "user_name" },
          { header: "Payment Intent Id", key: "payment_intent_id" },
          { header: "Subtotal Amount", key: "subtotal_amount" },
          { header: "After Deduction", key: "amount_after_deduction" },
          { header: "Credit", key: "credit_added" },
          { header: "Payment Method", key: "payment_method_type" },
          { header: "Status", key: "status" },
          { header: "Initiated Date", key: "created_date" },
          { header: "Processed Date", key: "updated_date" },
      ]
    };

    const handleDownload = () => {
      // 1. Prepare status summary as array of arrays
      // const statusSummary = [
      //   ["Status Summary"], // Title row
      //   ...status.map(stat => [`${stat.status} - ${stat.count}`]), // Each status
      //   [`Total - ${status.reduce((sum, s) => sum + s.count, 0)}`], // Total row
      //   [], // Empty row for spacing
      // ];

      // 2. Prepare order data as array of objects
      // const dataToExport = report.map((item) => ({
      //   "Order Number": item.order,
      //   // "File Number": item.file_num,
      //   "Product Type":item.product_type,
      //   "Credit Used":item.credit_used,
      //   // "Order Date": item.created_date?.split("T")[0],
      //   "Order Date": item.created_date ? new Date(item.created_date).toLocaleDateString('en-US') : '',
      //   // "Organization": item.org_detail?.name,
      //   // "Processed Date": item.updated_date?.split("T")[0] || "-",
      //   // "Processed Date": item.updated_date? new Date(item.updated_date).toLocaleDateString('en-US') : '',
      //   "Status": item.status,
      // }));

      const columns = reportColumns[reportType] || [];

      // 3. Convert order data to array of arrays
      // const orderSheetData = [
      //   Object.keys(dataToExport[0]), // Header row
      //   ...dataToExport.map(Object.values),
      // ];

      const orderSheetData = [
          columns.map(col => col.header),

          ...report.map(row =>
              columns.map(col => {
                  const value = row[col.key];

                  if (
                      col.key === "created_date" ||
                      col.key === "updated_date"
                  ) {
                      return value
                          ? new Date(value).toLocaleDateString("en-US")
                          : "";
                  }

                  return value ?? "";
              })
          )
      ];

      // 4. Combine both into final sheet data
      // const finalSheetData = [...statusSummary, ...orderSheetData];
      const finalSheetData = [ ...orderSheetData];

      // 5. Create worksheet and workbook
      const worksheet = XLSX.utils.aoa_to_sheet(finalSheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

      // 6. Download
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });

      saveAs(dataBlob, `${reportType}_${today}.xlsx`);
    }

  return (
    <Container fluid> 
      <Row>
        <Col>
          <Row className='mt-2'>
            <Col>
              <Button color="primary" onClick={handleDownload}>
                Download Report (xls)
              </Button>
            </Col>
          </Row>

          <Row className='mt-3'>
            <Col>
              {dateData === today ? <h6>Daily Report Summary - {dateData}</h6> : <h6>Report Summary from {dateData.startDate} to {dateData.endDate}</h6>}
            </Col>
          </Row>
          {/* <Row>
            <Col>
              <h6>Status Summary</h6>
              <ul style={{ paddingLeft: '1rem' }}>
                {status?.map((stat,index)=>(
                  <li key={index}>{stat.status} - {stat.count}</li>
                ))}
                <li>
                  Total - {status?.reduce((total,item)=>total+ item.count,0)}
                </li>
              </ul>
            </Col>
          </Row> */}
          { reportType === 'credit_report' &&
            <Row>
                <div className='table-rep-plugin'>
                    <div className='table-responsive mb-0' style={{ maxHeight: "400px",minHeight:"340px", overflowY: "auto" }}>
                        <Table className='table table-striped table-bordered'>
                            <Thead>
                                <Tr>
                                    <Th style={stickyHeaderStyle}>User</Th>
                                    <Th style={stickyHeaderStyle}>Order Number</Th>
                                    <Th style={stickyHeaderStyle}>Product Type</Th>
                                    <Th style={stickyHeaderStyle}>Credit Used</Th>
                                    <Th style={stickyHeaderStyle}>Order Date</Th>
                                    {/* <Th style={stickyHeaderStyle}>Organization</Th> */}
                                    {/* <Th style={stickyHeaderStyle}>Processed Date</Th> */}
                                    {/* <Th style={stickyHeaderStyle}>Appraiser</Th> */}
                                    <Th style={stickyHeaderStyle}>Status</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {Array.isArray(report)&& report.map((repData, index)=>(
                                    <Tr key={index}>
                                        <Td>{repData.user_name}</Td>
                                        <Td>{repData.order}</Td>
                                        <Td>{repData.product_type}</Td>
                                        <Td>{repData.credit_used}</Td>
                                        {/* <Td>{repData.created_date?.split('T')[0]}</Td> */}
                                        <Td>{repData.created_date ? new Date(repData.created_date).toLocaleDateString('en-US') : ''}</Td>
                                        {/* <Td>{repData.org_detail.name}</Td> */}
                                        {/* <Td>{repData.updated_date?.split('T')[0] || '-'}</Td> */}
                                        {/* <Td>{repData.updated_date ? new Date(repData.updated_date).toLocaleDateString('en-US') : ''}</Td> */}
                                        {/* <Td>{repData.}</Td> */}
                                        <Td>{repData.status}</Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </div>
                </div>
          </Row>
          }
          
          { reportType === 'payment_report' &&
            <Row>
                <div className='table-rep-plugin'>
                    <div className='table-responsive mb-0' style={{ maxHeight: "400px",minHeight:"340px", overflowY: "auto" }}>
                        <Table className='table table-striped table-bordered'>
                            <Thead>
                                <Tr>
                                    <Th style={stickyHeaderStyle}>User</Th>
                                    <Th style={stickyHeaderStyle}>Payment Intent Id</Th>
                                    <Th style={stickyHeaderStyle}>Subtotal Amount</Th>
                                    {/* <Th style={stickyHeaderStyle}>After Deduction</Th> */}
                                    <Th style={stickyHeaderStyle}>Credit</Th>
                                    <Th style={stickyHeaderStyle}>Payment Method</Th>
                                    <Th style={stickyHeaderStyle}>Status</Th>
                                    <Th style={stickyHeaderStyle}>Initiated Date</Th>
                                    <Th style={stickyHeaderStyle}>Processed Date</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {Array.isArray(report)&& report.map((repData, index)=>(
                                    <Tr key={index}>
                                        <Td>{repData.user_name}</Td>
                                        <Td>{repData.payment_intent_id}</Td>
                                        <Td>{repData.subtotal_amount}</Td>
                                        {/* <Td>{repData.amount_after_deduction}</Td> */}
                                        <Td>{repData.credit_added}</Td>
                                        <Td>{repData.payment_method_type}</Td>
                                        <Td>{repData.status}</Td>
                                        <Td>{repData.created_date ? new Date(repData.created_date).toLocaleDateString('en-US') : ''}</Td>
                                        <Td>{repData.updated_date ? new Date(repData.updated_date).toLocaleDateString('en-US') : ''}</Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </div>
                </div>
          </Row>
          }
        </Col>
      </Row>
    </Container>
  )
}

export default FinanceReportGeneration
